import React from 'react';

const Divider = () =>
    <section id="divider" className="clearfix main">
        <div className="container-fluid">
            <div className="row">
                <div className="col-xs-12 col-sm-offset-1 col-sm-8 col-md-offset-3 col-md-6 col-lg-5">
                    <h2 className="tab">Projects</h2>
                    <h2 className="tab">
                        <a href="http://chrislindeman.com/resume">Resume</a>
                    </h2>
                </div>
            </div>
        </div>
    </section>

export default Divider;
